var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-193.9 331.5 29 26",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-166 352.7l-10.9-18.9c-.7-1.2-1.6-1.8-2.5-1.8s-1.8.6-2.5 1.8l-10.9 18.9c-1.4 2.4-.3 4.3 2.5 4.3h21.8c2.7 0 3.8-1.9 2.5-4.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-190.4 357.5c-1.5 0-2.7-.5-3.2-1.5-.6-1-.5-2.2.3-3.5l10.9-18.9c.8-1.3 1.8-2 2.9-2 1.1 0 2.2.7 2.9 2l10.9 18.9c.8 1.3.9 2.5.3 3.5-.6 1-1.7 1.5-3.2 1.6h-21.8zm11-25c-.7 0-1.5.5-2.1 1.5l-10.9 18.9c-.6 1-.7 1.9-.3 2.5.4.7 1.2 1 2.4 1h21.8c1.1 0 2-.4 2.4-1 .4-.7.3-1.5-.3-2.5l-10.9-18.9c-.7-.9-1.4-1.5-2.1-1.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-180.9 340.4c0-.3.3-.6.6-.6h1.7c.3 0 .6.3.6.6v7.5c0 .3-.3.6-.6.6h-1.7c-.3 0-.6-.3-.6-.6v-7.5zm1.5 13.2c-.9 0-1.6-.7-1.6-1.6s.7-1.6 1.6-1.6 1.6.7 1.6 1.6-.8 1.6-1.6 1.6z"
  })));
}

export default SvgAlert;